export const scrollToElementWithOffset = (element, offset = 160) => {
    if (!element) return;

    const top = element.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
        top,
        behavior: 'smooth'
    });
};
